import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React from 'react';
import Box from '@rexlabs/box';
import { styled, StyleSheet } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  container: {
    minWidth: function minWidth(_ref) {
      var token = _ref.token;
      return token('select.menu.minWidth', '12rem');
    }
  }
});

function Menu(_ref2) {
  var s = _ref2.styles,
      innerRef = _ref2.innerRef,
      children = _ref2.children,
      width = _ref2.width,
      props = _objectWithoutProperties(_ref2, ["styles", "innerRef", "children", "width"]);

  return /*#__PURE__*/React.createElement(Box, _extends({}, s.with('container')({
    width: width
  }), props, {
    ref: innerRef
  }), children);
}

export default styled(defaultStyles)(Menu);